<template>
  <svg
    id="latency"
    x="0px"
    y="0px"
    viewBox="28 30 360 360"
    style="enable-background:new 28 30 360 360;"
    ref="svgLatency"
  >
    <title>Integrated circuit 3 : 20% reduced latency</title>
    <defs>
      <radialGradient cx="50%" cy="50%" fx="50%" fy="50%" r="50.68664%" id="radialGradient-1">
        <stop stop-color="#FFFFFF" offset="0%" />
        <stop stop-color="#FFFFFF" offset="100%" />
      </radialGradient>
      <filter
        x="-30.0%"
        y="-30.0%"
        width="160.0%"
        height="160.0%"
        filterUnits="objectBoundingBox"
        id="filter-2"
      >
        <feGaussianBlur stdDeviation="1" in="SourceGraphic" />
      </filter>
    </defs>
    <g>
      <text
        role="presentation"
        aria-hidden="true"
        transform="matrix(1 0 0 1 91.2754 241.4333)"
        class="st0 st1 st3"
      >reduced latency</text>
      <text
        role="presentation"
        aria-hidden="true"
        transform="matrix(1 0 0 1 143.5741 204.9999)"
        id="latency_counter"
        class="st0 st1 st2"
      >00</text>
      <text
        role="presentation"
        aria-hidden="true"
        transform="matrix(1 0 0 1 226.7741 204.9999)"
        class="st0 st1 st5"
      >%</text>
      <circle class="st4" cx="128.8" cy="48.4" r="13.2" />
      <circle class="st4" cx="128.8" cy="48.4" r="9.4" />
      <circle class="st4" cx="158.1" cy="48.4" r="9.4" />
      <path
        class="st4"
        d="M87.4,362.3H54.1c-1.2,0-2.1,0.9-2.1,2.1v14c0,1.2,0.9,2.1,2.1,2.1h33.3c1.2,0,2.1-0.9,2.1-2.1v-14
C89.5,363.3,88.5,362.3,87.4,362.3z"
      />
      <polyline
        class="st4"
        points="166.3,380.5 254.6,380.5 284,351.1 375.5,351.1 375.5,261 345.6,231 345.6,157.5 375.6,127.5
375.5,43.9 "
      />
      <circle class="st4" cx="120.4" cy="120.6" r="4.5" />
      <circle class="st4" cx="84.6" cy="144.1" r="4.5" />
      <circle class="st4" cx="49.3" cy="157.1" r="4.5" />
      <polyline class="st4" points="116,120.6 75.1,120.6 50,95.6 38.9,95.6 " />
      <path
        class="st4"
        d="M139.8,362.3h-33.3c-1.2,0-2.1,0.9-2.1,2.1v14c0,1.2,0.9,2.1,2.1,2.1h33.3c1.2,0,2.1-0.9,2.1-2.1v-14
C141.8,363.3,140.9,362.3,139.8,362.3z"
      />
      <circle class="st4" cx="135.8" cy="104.6" r="4.5" />
      <polyline class="st4" points="131.4,104.6 78.1,104.6 53,79.6 38.9,79.6 " />
      <circle class="st4" cx="135.8" cy="88.6" r="4.5" />
      <circle class="st4" cx="34.5" cy="95.6" r="4.5" />
      <circle class="st4" cx="50.5" cy="120.6" r="4.5" />
      <circle class="st4" cx="375.5" cy="39.5" r="4.5" />
      <circle class="st4" cx="359.6" cy="39.5" r="4.5" />
      <circle class="st4" cx="343.6" cy="39.5" r="4.5" />
      <circle class="st4" cx="313.6" cy="201.7" r="4.5" />
      <circle class="st4" cx="343.6" cy="279.1" r="4.5" />
      <circle class="st4" cx="161.8" cy="380.5" r="4.5" />
      <polyline
        class="st4"
        points="166.3,364.5 248.6,364.5 278,335.1 359.5,335.1 359.5,268 329.6,238 329.6,150.5 359.6,120.5
359.6,43.9 "
      />
      <circle class="st4" cx="161.8" cy="364.5" r="4.5" />
      <circle class="st4" cx="34.5" cy="79.6" r="4.5" />
      <circle class="st4" cx="34.5" cy="63.5" r="4.5" />
      <polyline class="st4" points="131.4,88.6 81.1,88.6 56,63.5 38.9,63.5 " />
      <circle class="st4" cx="34.5" cy="39.6" r="4.5" />
      <circle class="st4" cx="84.1" cy="39.6" r="4.5" />
      <polyline class="st4 reverse slowmo" points="79.7, 39.6, 38.9, 39.6" />
      <g>
        <path
          class="st4"
          d="M298.6,95.4h-90.5c-1.4,0-2.5-1.1-2.5-2.5V49.1c0-1.4,1.1-2.5,2.5-2.5h90.5c1.4,0,2.5,1.1,2.5,2.5v43.7
C301.1,94.2,300,95.4,298.6,95.4z"
        />
        <line class="st4" x1="213.3" y1="106.9" x2="213.3" y2="95.4" />
        <line class="st4" x1="221.3" y1="106.9" x2="221.3" y2="95.4" />
        <line class="st4" x1="229.3" y1="106.9" x2="229.3" y2="95.4" />
        <line class="st4" x1="293.3" y1="106.9" x2="293.3" y2="95.4" />
        <line class="st4" x1="285.3" y1="106.9" x2="285.3" y2="95.4" />
        <line class="st4" x1="237.3" y1="106.9" x2="237.3" y2="95.4" />
        <line class="st4" x1="213.3" y1="35" x2="213.3" y2="46.6" />
        <line class="st4" x1="221.3" y1="35" x2="221.3" y2="46.6" />
        <line class="st4" x1="229.3" y1="35" x2="229.3" y2="46.6" />
        <line class="st4" x1="293.3" y1="35" x2="293.3" y2="46.6" />
        <line class="st4" x1="285.3" y1="35" x2="285.3" y2="46.6" />
        <line class="st4" x1="237.3" y1="35" x2="237.3" y2="46.6" />
        <line class="st4" x1="245.3" y1="35" x2="245.3" y2="46.6" />
        <line class="st4" x1="253.3" y1="35" x2="253.3" y2="46.6" />
        <line class="st4" x1="261.3" y1="35" x2="261.3" y2="46.6" />
        <line class="st4" x1="253.3" y1="95.4" x2="253.3" y2="106.9" />
        <line class="st4" x1="261.3" y1="95.4" x2="261.3" y2="106.9" />
        <line class="st4" x1="269.3" y1="35" x2="269.3" y2="46.6" />
        <line class="st4" x1="277.3" y1="35" x2="277.3" y2="46.6" />
        <line class="st4" x1="245.3" y1="95.4" x2="245.3" y2="106.9" />
        <line class="st4" x1="269.3" y1="95.4" x2="269.3" y2="106.9" />
        <line class="st4" x1="277.3" y1="95.4" x2="277.3" y2="106.9" />
        <line class="st4" x1="312.7" y1="55" x2="301.1" y2="55" />
        <line class="st4" x1="205.5" y1="55" x2="194" y2="55" />
        <line class="st4" x1="205.5" y1="63" x2="194" y2="63" />
        <line class="st4" x1="301.1" y1="63" x2="312.7" y2="63" />
        <line class="st4" x1="205.5" y1="71" x2="194" y2="71" />
        <line class="st4" x1="301.1" y1="71" x2="312.7" y2="71" />
        <line class="st4" x1="312.7" y1="79" x2="301.1" y2="79" />
        <line class="st4" x1="205.5" y1="79" x2="194" y2="79" />
        <line class="st4" x1="205.5" y1="87" x2="194" y2="87" />
        <line class="st4" x1="301.1" y1="87" x2="312.7" y2="87" />
      </g>
      <circle class="st4" cx="34.5" cy="380.5" r="4.5" />
      <polyline
        class="st4"
        points="34.5,376.1 34.5,348.5 242.6,348.5 272,319.1 343.5,319.1 343.6,283.5 "
      />
      <circle class="st4" cx="34.5" cy="316.5" r="4.5" />
      <circle class="st4" cx="129.8" cy="316.5" r="4.5" />
      <line class="st4" x1="125.3" y1="316.5" x2="38.9" y2="316.5" />
      <circle class="st4" cx="208.8" cy="279.1" r="4.5" />
      <circle class="st4" cx="297.7" cy="298.8" r="4.5" />
      <circle class="st4" cx="34.5" cy="332.5" r="4.5" />
      <circle class="st4" cx="97.8" cy="332.5" r="4.5" />
      <line class="st4" x1="38.9" y1="332.5" x2="93.3" y2="332.5" />
      <circle class="st4" cx="310.3" cy="380.5" r="4.5" />
      <circle class="st4" cx="375.5" cy="380.5" r="4.5" />
      <line class="st4" x1="314.8" y1="380.5" x2="371.1" y2="380.5" />
      <circle class="st4" cx="161.8" cy="287.8" r="20" />
      <circle class="st4" cx="161.8" cy="287.8" r="14.2" />
      <circle class="st4" cx="209.4" cy="332.3" r="3.5" />
      <circle class="st4" cx="225.3" cy="332.3" r="3.5" />
      <circle class="st4" cx="209.4" cy="316.4" r="3.5" />
      <circle class="st4" cx="225.3" cy="316.4" r="3.5" />
      <circle class="st4" cx="241.2" cy="316.4" r="3.5" />
      <circle class="st4" cx="193.5" cy="332.3" r="3.5" />
      <circle class="st4" cx="225.3" cy="300.5" r="3.5" />
      <circle class="st4" cx="244.8" cy="122.3" r="3.5" />
      <circle class="st4" cx="292.5" cy="138.2" r="3.6" />
      <circle class="st4" cx="292.5" cy="154.1" r="3.6" />
      <circle class="st4" cx="292.5" cy="170" r="3.6" />
      <circle class="st4" cx="292.5" cy="185.9" r="3.6" />
      <circle class="st4" cx="260.7" cy="122.3" r="3.5" />
      <circle class="st4" cx="276.6" cy="122.3" r="3.6" />
      <circle class="st4" cx="292.5" cy="122.3" r="3.6" />
      <circle class="st4" cx="196.9" cy="122.3" r="3.5" />
      <circle class="st4" cx="212.8" cy="122.3" r="3.5" />
      <circle class="st4" cx="228.7" cy="122.3" r="3.5" />
      <circle class="st4" cx="165.1" cy="122.3" r="3.5" />
      <circle class="st4" cx="181" cy="122.3" r="3.5" />
      <circle class="st4" cx="149.2" cy="122.3" r="3.5" />
      <circle class="st4" cx="276.6" cy="138.2" r="3.6" />
      <circle class="st4" cx="276.6" cy="154.1" r="3.6" />
      <circle class="st4" cx="260.7" cy="138.2" r="3.5" />
      <circle class="st4" cx="244.8" cy="138.2" r="3.5" />
      <g>
        <path
          class="st4"
          d="M79.3,287H44.1c-1.4,0-2.5-1.1-2.5-2.5v-26.3c0-1.4,1.1-2.5,2.5-2.5h35.3c1.4,0,2.5,1.1,2.5,2.5v26.2
C81.9,285.9,80.8,287,79.3,287z"
        />
        <line class="st4" x1="93.4" y1="263.5" x2="81.9" y2="263.5" />
        <line class="st4" x1="41.6" y1="263.5" x2="30" y2="263.5" />
        <line class="st4" x1="41.6" y1="271.5" x2="30" y2="271.5" />
        <line class="st4" x1="49.3" y1="298.5" x2="49.3" y2="287" />
        <line class="st4" x1="57.3" y1="298.5" x2="57.3" y2="287" />
        <line class="st4" x1="65.3" y1="298.5" x2="65.3" y2="287" />
        <line class="st4" x1="73.3" y1="298.5" x2="73.3" y2="287" />
        <line class="st4" x1="81.9" y1="271.5" x2="93.4" y2="271.5" />
        <line class="st4" x1="41.6" y1="279.5" x2="30" y2="279.5" />
        <line class="st4" x1="81.9" y1="279.5" x2="93.4" y2="279.5" />
        <line class="st4" x1="73.3" y1="244" x2="73.3" y2="255.6" />
        <line class="st4" x1="57.3" y1="244" x2="57.3" y2="255.6" />
        <polyline class="st4" points="65.5,255.6 65.5,203.3 84.6,184.2 84.6,148.5 " />
        <polyline class="st4 reverse" points="49.3, 255.6, 49.3, 161.5" />
        <polyline class="st4" points="38.9, 316.5, 125.3, 316.5" />
        <polyline class="st4 slowmo" points="38.9, 332.5, 93.3, 332.5" />
        <polyline class="st4 slowmo" points="314.8, 380.5, 371.1, 380.5" />
      </g>
      <polyline class="st4 reverse" points="116, 120.6, 54.9, 120.6" />
      <polyline class="st4" points="293.2,298.8 264.6,298.8 244.9,279.1 213.3,279.1 " />
      <line class="st4" x1="60.1" y1="371.4" x2="81.3" y2="371.4" />
      <line class="st4" x1="112.5" y1="371.4" x2="133.7" y2="371.4" />
      <polyline class="st4" points="313.6,197.2 313.6,143.5 343.6,113.5 343.6,43.9 " />
    </g>

    <circle
      class="light"
      cx="0"
      cy="0"
      r="3"
      transform="translate(-100,-100)"
      fill="url('#radialGradient-1')"
      filter="url('#filter-2')"
    />
  </svg>
</template>

<script>
import { gsap, TweenLite } from "gsap";
import { MotionPathPlugin } from "gsap/MotionPathPlugin.js";
import { inView } from "../../helpers/inView";

gsap.registerPlugin(MotionPathPlugin);

export default {
  name: "LatencySvg",
  data: function() {
    return {
      hasAnimated: false
    };
  },
  methods: {
    getLen(path) {
      let p = document.createElementNS("http://www.w3.org/2000/svg", "path");
      p.setAttribute("d", path);
      return p.getTotalLength();
    },
    countUp() {
      let latencyCount = { fps: 0 };
      let latencyEle = document.getElementById("latency_counter");

      TweenLite.to(latencyCount, 1, {
        fps: "+=20",
        roundProps: "fps",
        ease: "linear",
        onUpdate: updateHandler
      });

      function updateHandler() {
        latencyEle.textContent = ("0" + latencyCount.fps).slice(-2);
      }
    },
    checkInView() {
      if (!this.hasAnimated) {
        this.hasAnimated = inView("#latency", this.countUp, "inBetween");
      } else {
        document.removeEventListener("scroll", this.checkInView);
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      let paths = document.querySelectorAll("#latency polyline.st4");
      let light = document.querySelector("#latency .light");
      let lights = [];
      let mPaths = [];
      let durations = [];
      let directions = [];

      for (let path in paths) {
        if (paths.hasOwnProperty(path)) {
          let polyline = paths[path];
          let line;
          if (polyline.nodeName !== "path") {
            line = `M${paths[path].getAttribute("points")}`;
          } else {
            line = polyline.getAttribute("d");
          }
          this.getLen(line);

          let l = light.cloneNode(true);
          this.$refs.svgLatency.appendChild(l);

          lights.push(l);
          mPaths.push(line);
          if ((polyline.classList) && (polyline.classList.contains("slowmo"))) {
            durations.push(this.getLen(line) * 0.03);
          } else {
            durations.push(this.getLen(line) * 0.013);
          }
          directions.push((polyline.classList) && (polyline.classList.contains("reverse")));
        }
      }
      gsap.to(lights, {
        motionPath: {
          path: index => mPaths[index],
          start: 1,
          end: 0
        },
        duration: index => durations[index],
        stagger: { repeat: -1, each: 0.05, ease: "power2" },
        ease: "linear"
      });

      document.addEventListener("scroll", this.checkInView);
    });
  }
};
</script>

<style scoped lang="scss">
#latency {
  padding: 0px 10px;

  @media screen and (max-width: 767px) {
    padding: 25px;
  }
}

.st0 {
  fill: #fff;
}

.st1 {
  font-family: "Verizon", Helvetica, Arial, sans-serif;
  font-weight: bold;
}

.st2 {
  font-size: 65px;
}

.st3 {
  font-size: 30px;
}

.st4 {
  fill: none;
  stroke: #fff;
  stroke-width: 2;
  stroke-miterlimit: 10;
}

.st5 {
  font-size: 40px;
}

@include media-breakpoint-down(sm) {
  #latency {
    display: block;
  }
}
</style>
